import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./Components/Login";
import Register from "./Components/Registeremp";
import AdminDashboard from "./Pages/AdminDashboard";
import UserDashboard from "./Pages/UserDashboard";
import Ladmin from "./Pages/Ladmin";
import ProtectedRoute from "./Components/ProtectedRoute";
// import Room from "./Components/Room";
// import Bathrooms from "./Components/Bathrooms"; 
// import Bhistory from "./Components/Bhistory";
// import Rhistory from "./Components/Rhistory";
// import Message from "./Components/Message";
// import Message2 from "./Components/Message2";
import ScanQR from "./Components/ScanQR";
import QrPage from "./Components/QrPage";
import View from "./Components/View";
import History from "./Components/History";
import Location from "./Components/Location";
import Useraccount from "./Components/Useraccount";
import Viewonlyhotel from "./Components/Viewonlyhotel";
import Lregister from "./Components/Lregister";
import Historycl from "./Components/Historycl";
import Observation from "./Components/Observation";
import Sadmin from "./Pages/sadmin";
import Lsadmin from "./Pages/Lsadmin";
import Securitydash from "./Components/Securitydash";
import Securityscanqr from "./Components/Securitysacnqr";
import Securityqrpage from "./Components/Securityqrpage";
import Viewsp from "./Components/Viewsp";
import ViewspLake from "./Components/ViewspLake";
import Asummery from "./Components/Asummery";
import Asecuritysum from "./Components/admin/Asecuritysum";
import SAsummery from "./Components/superadmin/SAsummery";
import SAsecuritysum from "./Components/superadmin/SAsecuritysum";
import Vehiclescan from "./Components/security/Vehiclescan";
import Viewvehicle from "./Components/security/Viewvehicle";
import Viewvehicle1 from "./Components/admin/Viewvehicle1";
import DisplayObs from "./Components/DisplayObs";
import Obs from "./Components/admin/obs";
import Aobs from "./Components/admin/Aobs";
import AVS from "./Components/admin/AVS";
import SAVS from "./Components/superadmin/SAVS";
import DriverDash from "./Components/DriverDash";
import DriverAdmin from "./Components/DriverAdmin"
import Txtadmin from "./Pages/txtadmin";
import Txtsadmin from "./Pages/txtsadmin";
import Viewtxt from "./Sarathchandra_Textile/viewtxt";
import Viewsptxt from "./Sarathchandra_Textile/viewsptxt";
import ViewSummery from "./Sarathchandra_Textile/viewsummery";
import SecuritySum from "./Sarathchandra_Textile/securitysum";
import TxtObs from "./Sarathchandra_Textile/txtobs";
import Txtaccount from "./Sarathchandra_Textile/txtaccount";
import Register1 from "./Sarathchandra_Textile/register1";
import Locationtxt from "./Sarathchandra_Textile/locationtxt";


function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute role="admin">
              <Ladmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/txtsadmin"
          element={
            <ProtectedRoute role="admin">
              <Txtsadmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/superadmin"
          element={
            <ProtectedRoute role="Superadmin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedRoute role="employee">
              <UserDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/driverdash"
          element={
            <ProtectedRoute role="Superadmin">
              <DriverDash />
            </ProtectedRoute>
          }
        />

        <Route
          path="/driverdash"
          element={
            <ProtectedRoute role="driver">
              <DriverDash />
            </ProtectedRoute>
          }
        />
        
        <Route path="/scanqr" element={<ScanQR />} />
        <Route path="/qrpage" element={<QrPage />} />
        <Route path="/view" element={<View />} />
        <Route path="/history" element={<History />} />
        <Route path="/location" element={<Location />} />
        <Route path="/useraccount" element={<Useraccount />} />
        <Route path="/viewonlyhotel" element={<Viewonlyhotel />} />
        <Route path="/lregister" element={<Lregister />} />
        <Route path="/historycl" element={<Historycl />} />
        <Route path="/observation" element={<Observation />} />
        <Route path="/sadmin" element={<Sadmin />} />
        <Route path="/lsadmin" element={<Lsadmin />} />
        <Route path="/securitydash" element={<Securitydash />} />
        <Route path="/securityscanqr" element={<Securityscanqr />} />
        <Route path="/securityqrpage" element={<Securityqrpage />} />
        <Route path="/viewsp" element={<Viewsp />} />
        <Route path="/viewspLake" element={<ViewspLake />} />
        <Route path="/asummery" element={<Asummery />} />
        <Route path="/asecuritysum" element={<Asecuritysum />} />
        <Route path="/sasummery" element={<SAsummery />} />
        <Route path="/sasecuritysum" element={<SAsecuritysum />} />
        <Route path="/vehiclescan" element={<Vehiclescan />} />    
        <Route path="/viewvehicle" element={<Viewvehicle />} />  
        <Route path="/viewvehicle1" element={<Viewvehicle1 />} />  
        <Route path="/displayobs" element={<DisplayObs />} /> 
        <Route path="/obs" element={<Obs />} />
        <Route path="/aobs" element={<Aobs />} />
        <Route path="/avs" element={<AVS />} />
        <Route path="/savs" element={<SAVS />} />
        <Route path="/driveradmin" element={<DriverAdmin />} />
        <Route path="/txtadmin" element={<Txtadmin />} />      
        <Route path="/viewtxt" element={<Viewtxt />} />
        <Route path="/viewsptxt" element={<Viewsptxt />} />
        <Route path="/viewsummery" element={<ViewSummery />} />
        <Route path="/securitysum" element={<SecuritySum />} />
        <Route path="/txtobs" element={<TxtObs />} />
        <Route path="/txtaccount" element={<Txtaccount />} />
        <Route path="/register1" element={<Register1 />} />
        <Route path="/locationtxt" element={<Locationtxt />} />
          
      </Routes>
    </Router>
    
  );
}

export default App;
 